import { render, staticRenderFns } from "./EditDetailDialog.vue?vue&type=template&id=dae9c5ea"
import script from "./EditDetailDialog.vue?vue&type=script&lang=js"
export * from "./EditDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports